import { render, staticRenderFns } from "./rent.vue?vue&type=template&id=12f24e8a&scoped=true"
import script from "./rent.vue?vue&type=script&lang=js"
export * from "./rent.vue?vue&type=script&lang=js"
import style0 from "./rent.vue?vue&type=style&index=0&id=12f24e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f24e8a",
  null
  
)

export default component.exports